import React from 'react'
import { Card, Col, Row, Button, Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTrash } from '@fortawesome/pro-solid-svg-icons'
import CheckBoxRadioButtonInput from 'components/ui/forms/field/checkbox-radiobutton/CheckBoxRadioButtonInput'
import { useSelector } from 'react-redux'
import { IMainState } from 'store/states'
import Loader, { LoaderSizes } from 'components/ui/loader/Loader'
import styles from './SurveyQuestionCard.module.scss'

interface ISurveyQuestionCard {
  id: number
  index: number
  name: string
  type: string
  mandatory: boolean
  onEdit: any
  onDelete: any
  options: any
}

const SurveyQuestionCard: React.FC<ISurveyQuestionCard> = ({
  index,
  name,
  type,
  mandatory,
  options,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation()

  const { loading } = useSelector(({ questions }: IMainState) => questions)

  const prepateType = () => {
    let result = ''
    result = t('administration.blocks.type.survey.question.answerType')
    const currentType =
      type[0].toLowerCase() + type.substring(1).replace(/\s/g, '')
    result = `${result}:  ${t(
      `administration.blocks.type.survey.question.${currentType}`
    )}`
    return result
  }
  return (
    <Card className={'p-3 mb-3 d-flex'}>
      {loading ? (
        <Loader sizes={LoaderSizes.ExtraSmall} color />
      ) : (
        <>
          <Row className={'mt-2'}>
            <Col xs={8}>
              <h2 className={styles.title}>{`${t(
                'administration.blocks.type.survey.question.singular'
              )} ${index + 1}`}</h2>
            </Col>
            <Col xs={4} className={styles.actionButtons}>
              <Button className={`ml-3`} onClick={onEdit}>
                <FontAwesomeIcon size={'xs'} icon={faPen} />
              </Button>
              <Button className={`ml-2`} onClick={onDelete}>
                <FontAwesomeIcon size={'xs'} icon={faTrash} />
              </Button>
            </Col>
          </Row>
          <div className={'mt-2'}>
            <h3 className={styles.questionName}>{name}</h3>
          </div>
          <div className={'mt-3'}>
            <p className={styles.questionDetails}>
              <b>{prepateType()}</b>{' '}
              {mandatory
                ? t('administration.blocks.type.survey.question.mandatory')
                : ''}
            </p>
          </div>
          {type === 'Likert' && (
            <Form.Group className={'m-0 mt-1'}>
              {options.map(({ label, id }: any) => {
                return (
                  <CheckBoxRadioButtonInput
                    key={id}
                    name={label + id}
                    value={true}
                    checked={false}
                    inline={true}
                    type={'radio'}
                    label={<b>{label}</b>}
                    disabled={true}
                    error={''}
                  />
                )
              })}
            </Form.Group>
          )}
        </>
      )}
    </Card>
  )
}

export default SurveyQuestionCard
